module.exports = __webpack_public_path__ + "img/02.6531a9a8.png";